const STAGE_COLOR_CLASSES = [
  "bg-primary",
  "bg-info",
  "bg-warning",
  "bg-purple",
  "bg-success",
  "bg-danger",
  "bg-pink",
  "bg-teal",
];

const STAGE_COLOR_VALUES = [
  "#0d6efd",
  "#0dcaf0",
  "#ffc107",
  "#6f42c1",
  "#198754",
  "#dc3545",
  "#d63384",
  "#20c997",
];

const STAGE_DOT_CLASSES = [
  "text-primary",
  "text-info",
  "text-warning",
  "text-purple",
  "text-success",
  "text-danger",
  "text-pink",
  "text-teal",
];

export const getStageColorByOrder = (stageOrder: number): string => {
  if (!stageOrder || stageOrder < 1) {
    return STAGE_COLOR_CLASSES[0];
  }

  const index = (stageOrder - 1) % STAGE_COLOR_CLASSES.length;
  return STAGE_COLOR_CLASSES[index];
};

export const getStageColorValueByOrder = (stageOrder: number): string => {
  if (!stageOrder || stageOrder < 1) {
    return STAGE_COLOR_VALUES[0];
  }

  const index = (stageOrder - 1) % STAGE_COLOR_VALUES.length;
  return STAGE_COLOR_VALUES[index];
};

export const getStageDotClassByOrder = (stageOrder: number): string => {
  if (!stageOrder || stageOrder < 1) {
    return STAGE_DOT_CLASSES[0];
  }

  const index = (stageOrder - 1) % STAGE_DOT_CLASSES.length;
  return STAGE_DOT_CLASSES[index];
};

export const getStageColor = (
  stageName?: string,
  stageId?: number,
  stageOrder?: number
): string => {
  if (typeof stageOrder === "number" && stageOrder > 0) {
    return getStageColorByOrder(stageOrder);
  }

  if (stageId && stageId > 0) {
    return getStageColorByOrder(stageId);
  }

  if (stageName) {
    const stageNameLower = stageName.toLowerCase();
    if (stageNameLower.includes("won") || stageNameLower.includes("closed")) {
      return "bg-success";
    }
    if (
      stageNameLower.includes("lost") ||
      stageNameLower.includes("rejected")
    ) {
      return "bg-danger";
    }
    if (
      stageNameLower.includes("pending") ||
      stageNameLower.includes("waiting")
    ) {
      return "bg-primary";
    }
    if (
      stageNameLower.includes("qualified") ||
      stageNameLower.includes("proposal")
    ) {
      return "bg-info";
    }
    if (
      stageNameLower.includes("negotiation") ||
      stageNameLower.includes("meeting")
    ) {
      return "bg-warning";
    }
    if (
      stageNameLower.includes("contact") ||
      stageNameLower.includes("initial")
    ) {
      return "bg-purple";
    }
  }

  return STAGE_COLOR_CLASSES[0];
};

export const getStageColorValue = (index: number): string => {
  return STAGE_COLOR_VALUES[index % STAGE_COLOR_VALUES.length];
};

export const getStageDotClass = (index: number): string => {
  return STAGE_DOT_CLASSES[index % STAGE_DOT_CLASSES.length];
};
